import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function assertUnreachable(x: never): never {
  throw new Error(`Unreachable: ${String(x)}`);
}

